<div class="carousel-background__wrapper">
    <div class="root-container">
        <div class="carousel_wrapper">
            <carousel [isAnimated]="true" >
                <slide class="carousel" *ngFor="let item of items; let i = index ">
                    <app-carousel-item class="row" [item]="item"></app-carousel-item>
                </slide>
            </carousel>
        </div>
    </div>
</div>
